import { type FC } from 'react';

import { getAdTileSizeVars } from '../utils/getAdTileSizeVars.ts';
import { PRODUCT_TILE_WIDTH, PRODUCT_TILE_HEIGHT } from '../constants.ts';
import { type AdTileDimensions } from '../types.ts';

import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from '../styles/ads.scss';

type Props = Partial<AdTileDimensions> & {
    className?: string;
};

const ProductTileAdPlaceholder: FC<Props> = ({
    className,
    width = PRODUCT_TILE_WIDTH,
    height = PRODUCT_TILE_HEIGHT,
    widthHold,
    heightHold,
}) => (
    <div
        className={classnames(
            styles.tileBox,
            dibsCss.loadingShimmer,
            dibsCss.rounded2px,
            className
        )}
        style={getAdTileSizeVars({ width, height, widthHold, heightHold })}
        data-tn="product-tile-ad-placeholder"
    />
);

export { ProductTileAdPlaceholder };
